import { hiddenUserData } from "helpers/hiddenData";
import React from "react";

const Mechanic = ({ mechanic }) => {
    if (!mechanic) {
        return null;
    }
    return (
        <>
            <div className="show-bid__main-info--title">Механик</div>
            <div className="show-bid__main-info--value" data-test-id="mechanic">
                {mechanic.name && <span className="text-muted pr-1">{mechanic.name}</span>}
                {mechanic.phoneNumber && (
                    <span className="text-muted pr-1">({hiddenUserData(mechanic.phoneNumber, { type: "phone" })})</span>
                )}
            </div>
        </>
    );
};

export default Mechanic;
